<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>ZigZag No Heading No Button:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
          ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event,'ZigZagNhnbImage')"
            [blockData]="block.variables?.ZigZagNhnbImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="ZigZagNhnbImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagNhnbImageHref')"
            [blockData]="block.variables?.ZigZagNhnbImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="ZigZagNhnbImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ZigZagNhnbImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.ZigZagNhnbImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event,'ZigZagNhnbImageAlt')"
            [blockData]="block.variables?.ZigZagNhnbImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="ZigZagNhnbImageAlt"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event,'ZigZagNhnbText')"
            [blockData]="block.variables?.ZigZagNhnbText ?? ''"
            [placeholder]="textPlaceholder"
            variable="ZigZagNhnbText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div *ngIf="block.variables?.ZigZagNhnbImage" class="col-6">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ZigZagNhnbImageHref))"
            ><img
              [src]="$safeNavigationMigration(block.variables?.ZigZagNhnbImage)"
              class="img-fluid"
              [alt]="$safeNavigationMigration(block.variables?.ZigZagNhnbImageAlt)"
            /></a>
          </div>
          <div
            class="col-6"
            [innerHTML]="$safeNavigationMigration(block.variables?.ZigZagNhnbText)"
          ></div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
